var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHousekeeping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20592_15885)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20592_15885",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.90735e-06H24V24H0V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20592_15885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78125 15.2812C7.78125 13.3396 6.20728 11.7656 4.26562 11.7656C6.20728 11.7656 7.78125 10.1916 7.78125 8.25C7.78125 10.1916 9.35522 11.7656 11.2969 11.7656C9.35522 11.7656 7.78125 13.3396 7.78125 15.2812Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.56236 23.6874C3.54506 21.7602 1.93116 20.2031 0 20.2031C1.94166 20.2031 3.5625 18.6292 3.5625 16.6875C3.5625 18.6292 5.13647 20.2031 7.07812 20.2031C5.13647 20.2031 3.5625 21.7771 3.5625 23.7188C3.5625 23.7083 3.56245 23.6979 3.56236 23.6874Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3389 0.516548L19.2085 11.7441",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8013 14.2666L21.7298 17.1523",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3704 14.0291L20.049 13.5482C20.3146 12.8183 19.9383 12.0114 19.2085 11.7457C18.4787 11.4801 17.6717 11.8564 17.4061 12.5862L16.0846 12.1053C15.3548 11.8397 14.5479 12.2159 14.2822 12.9457L13.5716 14.8983C12.8202 16.9629 10.725 18.262 8.53711 18.0619C8.7623 18.6046 9.04266 19.1131 9.36998 19.5821C10.2802 20.8858 11.8629 21.6107 13.453 21.6107V22.6012C14.0273 22.7926 14.6002 22.8913 15.2108 22.8926C17.0443 22.8963 18.8239 21.9922 19.9247 20.4409C20.5425 19.5702 21.1894 18.477 21.73 17.153L22.2109 15.8316C22.4765 15.1018 22.1002 14.2948 21.3704 14.0291Z",
    stroke: "white",
    strokeWidth: 1.40625,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20592_15885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousekeeping);
export default __webpack_public_path__ + "static/media/Housekeeping.abfb637ca1363124848d4e00fe49e4a8.svg";
export { ForwardRef as ReactComponent };